export default {"src":"/_next/static/media/minus.c43069d8.svg","height":32,"width":32};